import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { STATUS_TYPES } from 'src/Constants';
import useAuth from 'src/hooks/useAuth';
import PageLoader from '../PageLoader';

const AuthWrapper = ({ children }) => {
	const { validateSession } = useAuth();
	const appInitializationStatus = useSelector(
		(state) => state.global.appInitializationStatus,
	);

	useEffect(() => {
		validateSession();
		return () => {};
	}, [validateSession]);

	return appInitializationStatus === STATUS_TYPES.SUCCESS ? (
		children
	) : (
		<PageLoader />
	);
};

export default AuthWrapper;
